import { Container, Grid, styled } from '@mui/material'
import InfoLabel from '../../components/Labels/InfoLabel'

export const Wrapper = styled(Container)``
export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};
  position: relative;

  &.MuiGrid-item {
    margin: ${props => props.margin};
  }

  &.labelContainer {
    position: relative;
    top: -35px;
  }
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]}

  &:hover{
    color: ${props => props.theme.palette.blue[35]}
  }

  &:visited{
    color: ${props => props.theme.palette.blue[50]}
  }
`
export const InfoLabelXaxis = styled(InfoLabel)`
  position: relative;
`
